import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // console.log('current url: ' + state.url);
    if (this.isLoggedIn()) {
      // Logged in so return true
      return true;
    } else {
      // Not logged in so redirect to login page with the return url and return false
      this.router.navigate(['/login'], { queryParams: { next: state.url }});
      return false;
    }
  }

  public isLoggedIn(): boolean {
    let token = localStorage.getItem('accessToken');
    return token !== null && token !== '' ? true : false;
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/service/auth-guard.service.ts